import React, { useState } from "react";
import { Typography, Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import globe from "assets/globe.png";
import ChangeTimeForm from "./ChangeTimeForm";
// Styling
import { CustomButton, CustomCard, CustomImage } from "./AfterSignUpStyle";

const AfterRegistrationStep2 = () => {
  const [showChangeForm, setShowChangeForm] = useState(false);

  const { t } = useTranslation("after_sign_up");
  const detectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const handleOnClickChange = () => setShowChangeForm(true);
  return (
    <CustomCard className="content">
      <Typography.Text>
        {t(
          "Is your time zone correct? Class times will be displayed in this time zone."
        )}
      </Typography.Text>
      {showChangeForm ? (
        <ChangeTimeForm />
      ) : (
        <div className="change">
          <Row gutter={4} align="middle">
            <Col span={6}>
              <CustomImage src={globe} alt="" className="icon" />{" "}
            </Col>
            <Col span={18}>
              <div className="timezone">
                {t("Your time zone is:")} <br />
                {detectedTimezone}
              </div>
            </Col>
          </Row>

          <CustomButton
            className="toggle-btn full"
            onClick={handleOnClickChange}
          >
            {t("Change").toUpperCase()}
          </CustomButton>
        </div>
      )}
    </CustomCard>
  );
};

export default AfterRegistrationStep2;
